import { LoyaltyProgram, ProgramStatus } from '@wix/ambassador-loyalty-v1-program/types';

export function getDemoLoyaltyProgram(): LoyaltyProgram {
  return {
    status: ProgramStatus.ACTIVE,
  };
}
